import React, { useContext, useState, useEffect, useMemo } from "react";
import { Form, Checkbox, Typography } from "antd";
import CheckListFBYInput from "../../../../../../blocks/FormItems/CheckListFBYInput";
import { getInitialValuesForChild } from "../../../../../../helpers/getInitialValues";
import { edemaOptions } from "../../../../Options/genExamOptions";
import { checkEmpty } from "../../../../../../helpers/utility";
import DynamicInputFields from "../../../../../../blocks/FormItems/DynamicInputFields";
const { Text } = Typography;
const Edema = ({ context, form }) => {
  const { formData } = useContext(context);
  const generalEdemaData = formData?.general_examination || formData;
  const initialValues = useMemo(() => generalEdemaData, [generalEdemaData]);
  const [checkboxes, setCheckboxes] = useState({});
  const initialState = edemaOptions.reduce(
    (state, checkbox) => ({
      ...state,
      [checkbox.value]: initialValues?.[checkbox.value] === true ? true : false,
    }),
    {}
  );
  const [state, setState] = useState(initialState);

  const handleChange = (value, checked) => {
    setState((prevState) => ({
      ...prevState,
      [value]: checked,
    }));
  };

  // Use useEffect to initialize checkboxes state based on initialValues
  useEffect(() => {
    const newState = edemaOptions.reduce(
      (newState, checkbox) => ({
        ...newState,
        [checkbox.value]:
          initialValues?.[checkbox.value] === true ? true : false,
      }),
      {}
    );
    setState({
      ...newState,
      edema_others: checkEmpty(initialValues?.edema_others),
    });

    edemaOptions.forEach(({ value }) => {
      setCheckboxes((prev) => {
        const res = getMoreEdemaOptions(value).reduce((acc, option) => {
          acc[option.value] = !!getInitialValuesForChild(
            getMoreEdemaOptions(value),
            initialValues || {}
          )[option.value];
          return acc;
        }, {});

        return { ...res, ...prev };
      });
    });
  }, [initialValues]); // Dependency array for re-initialization

  const getMoreEdemaOptions = (value) => [
    { label: "Pitting", value: `${value}_pitting` },
    { label: "Non Pitting", value: `${value}_non_pitting` },
  ];

  return (
    <>
      <Text>Edema</Text>
      {edemaOptions.map((checkbox) => (
        <>
          <Form.Item
            key={checkbox.value}
            valuePropName="checked"
            name={checkbox.value}
          >
            <Checkbox
              onChange={(e) => handleChange(checkbox.value, e.target.checked)}
              checked={state[checkbox.value]}
            >
              {checkbox.label}
            </Checkbox>
          </Form.Item>
          {state[checkbox.value] &&
            checkbox.value !== "none" &&
            checkbox.value !== "sacral" &&
            (checkbox.value === "edema_others" ? (
              <div className="subsection-card">
                <DynamicInputFields
                  field_key={"edema_others"}
                  form={form}
                  inputStyle={{ maxWidth: 800 }}
                />
              </div>
            ) : (
              <div className="subsection-card">
                <CheckListFBYInput
                  options={getMoreEdemaOptions(checkbox.value)}
                  checkboxes={checkboxes}
                  setCheckboxes={setCheckboxes}
                />
              </div>
            ))}
        </>
      ))}
    </>
  );
};

export default Edema;
